import * as React from 'react';

import CustomScrollbars from '../../common/CustomScrollbar';

import { Wrapper, Title, StyledScrollbars, ScrollButton } from './Card.styles';


interface IProps {
  children: any;
  className?: string;
  hidePatternBg?: boolean;
  scrollable?: boolean;
  scrollJumpSize?: number;
  maxHeight?: number;
  title?: string;
  subtitle?: any;
}

class ScrollCard extends React.Component<IProps> {
  public static defaultProps = {
    scrollable: false,
    scrollJumpSize: 200,
    maxHeight: 500,
  }

  public state = { scrolltop: 0 };
  private csbRef = React.createRef<CustomScrollbars>();

  constructor(props) {
    super(props);
  }

  public scrollContent = (direction) => {
    let newScrolltop = 0;
    const { scrolltop } = this.state;
    const scrollJumpSize = this.props.scrollJumpSize || 0;
    const scrollbarsRefs: any = this.csbRef.current && this.csbRef.current.refs.scrollbars;

    if (scrollbarsRefs === null) { return; }

    if (direction === 'up') {
      newScrolltop = scrolltop - scrollJumpSize;
    } else if (direction === 'down') {
      newScrolltop = scrolltop + scrollJumpSize;
    }

    if (newScrolltop >= 0) {
      scrollbarsRefs.scrollTop(newScrolltop);
      this.setState({ scrolltop: newScrolltop });
    }

    console.log(`Scrolltop ===> ${scrolltop}`);
  } 

  public scrollUp = () => this.scrollContent('up');
  public scrollDown = () => this.scrollContent('down');

  public renderScrollBtn(direction) {
    const iconClass = direction === 'up' ? 'fa-arrow-up' : 'fa-arrow-down';
    const scrollContent = direction === 'up' ? this.scrollUp : this.scrollDown;

    return (
      <ScrollButton direction={direction}>
        <button onClick={scrollContent}>
          <i className={`fa scroll-icon ${iconClass}`} aria-hidden="true" />
        </button>
      </ScrollButton>
    );
  }

  public renderMainContent() {
    const { children, scrollable, maxHeight } = this.props;

    if (scrollable) {
      return (
        <React.Fragment>
          {this.renderScrollBtn('up')}
          <CustomScrollbars className ="scrollcard-scrollbars" style={{ height: `${maxHeight}px` }} ref={this.csbRef}>
            {children}
          </CustomScrollbars>
          {this.renderScrollBtn('down')}
        </React.Fragment>
      );
    }

    return children;
  }

  /* tslint:disable jsx-no-string-ref */
  public render() {
    const { title, subtitle, className, hidePatternBg } = this.props;

    return (
      <Wrapper className={className} hidePatternBg={hidePatternBg}>
        {title ? <Title>{title}</Title> : null}
        {subtitle ? subtitle : null}
        {this.renderMainContent()}
      </Wrapper>
    );
  }
}

export default ScrollCard;



// WEBPACK FOOTER //
// ./src/components/Card/Card.tsx